import React, { useState } from 'react';

import ExcelSpreadsheet16Icon from '@atlaskit/icon-file-type/glyph/excel-spreadsheet/16';

import { LoadingButtonWithTooltip } from '@qality/common-components/src/molecules/LoadingButtonWithTooltip';
import { FEATURE_FLAG } from '@qality/common-config';
import { StorageOfUniqueServices } from '@qality/common-service';

import { ExcelIconStyled } from './ExportButtonStyled';

type ExportToExcelButtonProps = {
  exportExcel: () => Promise<void>;
};

const ExportToExcelButton: React.FC<ExportToExcelButtonProps> = ({
  exportExcel,
}: ExportToExcelButtonProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleExportReportToExcelClicked = () => {
    setIsLoading(true);
    exportReportToExcel();
  };

  const exportReportToExcel = async () => {
    try {
      await exportExcel();
    } catch (error) {
      StorageOfUniqueServices.get('ErrorHandlingUtils').handleError(
        error,
        "We couldn't export your execution report. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <LoadingButtonWithTooltip
      loadingButtonProps={{
        onClick: handleExportReportToExcelClicked,
        isDisabled: !FEATURE_FLAG.isPremium,
        iconAfter: (
          <ExcelIconStyled isDisabled={!FEATURE_FLAG.isPremium}>
            <ExcelSpreadsheet16Icon label='Export' />
          </ExcelIconStyled>
        ),
        isLoading: isLoading,
      }}
      tooltipProps={{
        content: !FEATURE_FLAG.isPremium
          ? 'Export is available only in QAlity Plus.'
          : '',
      }}
    >
      Export
    </LoadingButtonWithTooltip>
  );
};
export default ExportToExcelButton;
